import * as React from "react"
import {useStaticQuery, graphql} from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {fontColorBlue,fontFaceMoontime,fontSizeFive,fontColorDark} from './shared.module.scss'
import { Link } from "gatsby"

const McKinleyApartmentsBlock = ()=>{
  const data = useStaticQuery(graphql`
    query {
        contentfulCorporate {
            mcKinleyApartments {
              mcKinleyApartments
            }
            mcKinleyApartmentsImages {
              gatsbyImageData
            }
      }
    }
    `
  )

    let images = [];
    data.contentfulCorporate.mcKinleyApartmentsImages.map((i)=>{
        images.push(getImage(i));
    });
    return(
        <section >
            <div className=" container">
        <br />
        <br />
                <div className="columns is-mobile is-multiline" style={{alignItems:'center',textAlign:'center'}}>
                    <div className="column  is-full-mobile">
                        <h1 className={fontColorBlue+' '+fontSizeFive+' '+fontFaceMoontime} >McKinley Apartments</h1>
                        <p className={fontColorDark}>{data.contentfulCorporate.mcKinleyApartments.mcKinleyApartments}</p>
                        <br />
                        <br />
                        <Link to="/about/" className="button is-large is-link">Learn More</Link>
                    </div>
                </div>
                <div className="columns is-mobile is-multiline" style={{marginTop:'10rem'}}>
                    {images.map((image, index)=>(
                        <div key={index} className="column is-full-mobile has-text-centered" style={{}}><GatsbyImage image={image} alt="" style={{maxHeight:'200px'}}/></div>
                    ))}
                </div>
            </div>
        <br />
        <br />
        </section>
    )
}


export default McKinleyApartmentsBlock
